import { useQuery } from '@apollo/react-hooks'
import { gql } from 'apollo-boost'
import {
  SearchByPairingCode,
  SearchByPairingCodeVariables
} from '../../board/hooks/__generated__/SearchByPairingCode'

const QUERY = gql`
  query SearchByPairingCode($input: ConfigurationNetworkQueryInput!) {
    configurationNetwork(input: $input) {
      id
      ssid
      wpa2Key
      deviceId
      device {
        id
        model {
          id
          title
        }
        latestHeartbeat {
          id
          networks {
            ssid
            ipAddress
            online
            type
          }
        }
      }
    }
  }
`

export const useSearchByPairingCode = (pairingCode: string) => {
  return useQuery<SearchByPairingCode, SearchByPairingCodeVariables>(QUERY, {
    variables: {
      input: {
        pairingCode
      }
    }
  })
}
